

function parseHintsFromLocation() {
  let hints = window.location.hash.substring(1);
  if (!hints) {
    hints = window.location.search.substring(1);
  }
  hints = encodeURI(hints);
  return [parseHints(hints), hints];
}

function parseHints(hints) {
  let paramsArr = hints.split('&');
  return paramsArr.reduce((params, part) => {
    let [key, value] = part.split('=');
    if (key) {
      if (!value) {
        value = true;
      }
      params[key] = value;
    }
    return params;
  }, {});
}

const [HINTS, HINTS_STR] = parseHintsFromLocation();

export default HINTS;
export {HINTS_STR};